/* eslint-disable */
import { getUser } from '@service/current-user';
import { useQuery } from '@tanstack/react-query';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';
import { normalizeDashboardRange } from '../utils/dashboard-range';

interface MainUser {
  active: boolean;
  email: string;
  employed_by: string;
  function: string;
  roles: string[];
  username: string;
}

interface Context {
  mainUser: MainUser;
  setMainUser: Dispatch<SetStateAction<MainUser>>;
  startDate: any;
  setStartDate: Dispatch<SetStateAction<any>>;
  endDate: any;
  setEndDate: Dispatch<SetStateAction<any>>;
  operation: string | null;
  setOperation: Dispatch<SetStateAction<string | null>>;
  setor: string | null;
  setSetor: Dispatch<SetStateAction<string | null>>;
  equipament: string | null;
  setEquipament: Dispatch<SetStateAction<string | null>>;
}

interface GlobalMainProvider {
  children: ReactNode;
}

export const GlobalContext = createContext({} as Context);

export function GlobalProvider({ children }: GlobalMainProvider) {
  const [mainUser, setMainUser] = useState<MainUser>({
    active: false,
    email: '',
    employed_by: '',
    function: '',
    roles: [''],
    username: '',
  });

  const [initialRange] = useState(() => {
    localStorage.removeItem('StartDate');
    localStorage.removeItem('EndDate');
    return normalizeDashboardRange();
  });
  const [startDate, setStartDate] = useState<Date | undefined>(initialRange.start);
  const [endDate, setEndDate] = useState<Date | undefined>(initialRange.end);

  const [operation, setOperation] = useState<string | null>(localStorage.getItem("selectedDB"));
  const [setor, setSetor] = useState<string | null>(localStorage.getItem("selectedSetor"));
  const [equipament, setEquipament] = useState<string | null>(localStorage.getItem("selectedEquipament"));

  const mainValues = {
    mainUser,
    setMainUser,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    operation,
    setOperation,
    setor,
    setSetor,
    equipament,
    setEquipament,
  };

  return (
    <GlobalContext.Provider value={mainValues}>
      {children}
    </GlobalContext.Provider>
  );
}
